export default {"src":"/_next/static/media/iphone-old-charging.557e7489.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};